import { Card, Text, Title } from '@tremor/react';
import type { ReactNode } from 'react';

interface Props {
  /** Primary short message — the headline. */
  title?: string;
  /** Detail line. Most callers just pass this for backwards-compat with
   *  the previous bare-Text empty states. */
  message: string;
  /** Optional CTA — a Button or Link the user can click to recover. */
  action?: ReactNode;
  /** Skip the Card wrapper for when the empty state goes inside an existing
   *  section card. */
  bare?: boolean;
}

/**
 * Centered, friendly empty-state. Used when a list legitimately has zero
 * rows (no tickets in range, no parts matching the search, etc.) — visually
 * distinguishable from the loading or error states. Centering + the title
 * adds emotional weight so an empty result feels intentional rather than
 * broken.
 */
export default function EmptyState({ title, message, action, bare }: Props) {
  const body = (
    <div className="text-center py-8 space-y-2">
      {title && <Title>{title}</Title>}
      <Text className="text-tremor-content">{message}</Text>
      {action && <div className="pt-2">{action}</div>}
    </div>
  );
  return bare ? body : <Card>{body}</Card>;
}
